import { useState } from "react";
import * as XLSX from "xlsx";
import Navbar from "../components/Navbar";
import Pagination , { PagiSearch } from "../components/Pagination";
import { postApiSetting } from "../assets/functions";
import PageLoader from "../components/PageLoader";
import { TableStatusRow, StatusBadge } from "../components/UI";
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";

export default function Reversal ({setAuth}) {
 const navigate = useNavigate();

    const [reversalData, setReversalData] = useState([]);
    const [startOffset, setStartOffset] = useState(0);
    const [search, setSearch] = useState('');
    const [tableDataStatus, setTableDataStatus] = useState('');
    const [loaderON,setLoaderON] = useState(false)

    const itemsPerPage = 10;
    const searchData = reversalData.filter(item => Object.values(item).join("").toString().toLowerCase().includes(search.toLowerCase()))
    const endOffset = startOffset + itemsPerPage;
    const currentItems = searchData.slice(startOffset, endOffset)
    const pageCount = Math.ceil(searchData.length / itemsPerPage)

    // useEffect(()=>{
    //     setTableDataStatus('Loading...');
    //     (async()=>{
    //         try {
    //             let res = await fetch('/api/Admin/reportDataPayout', getApiSetting());
    //             let result = await res.json();
    //             console.log(res)
    //             console.log(result)
    //             if(res.status === 200){
    //                 if(result.data.length < 1){
    //                     setTableDataStatus('Not Found')
    //                 }else{
    //                     // let data = result.data.sort(function(a, b) {
    //                     //     let c = new Date(a.requestInitiatedDateTime);
    //                     //     let d = new Date(b.requestInitiatedDateTime);
    //                     //     return d-c;
    //                     // })
    //                     setTableDataStatus('')
    //                     setReversalData(result.data)
    //                 }
    //             }
    //         } catch (error) {
    //             console.log(error)
    //         }
    //     })()
    // },[])

    // const searchTransactions = async () => {
    //     let fDate = fromDateRef.current.value;
    //     let tDate =  toDateRef.current.value;
    //     if(!fDate || !tDate) {
    //         alert('Report date are required.')
    //         return false;
    //     }
    //     setTableDataStatus('Loading...')
    //     setReversalData([])
    //     let postSetting = postApiSetting({fDate,tDate})
    //     let res = await fetch('/api/Admin/reportDataByDatePayout', postSetting);
    //     let result = await res.json();
        
    //     if(res.status !== 200){
    //         alert('something went wrong : '+ res.status)
    //     }else{
    //         if(result.data.length < 1){
    //             setTableDataStatus('Not Found');
    //         }else{
    //             // let data = result.data.sort(function(a, b) {
    //             //     let c = new Date(a.requestInitiatedDateTime);
    //             //     let d = new Date(b.requestInitiatedDateTime);
    //             //     return d-c;
    //             // })
    //             setTableDataStatus('');
    //             setReversalData(result.data)
    //         }
    //     }
    // }

    // const downloadReport = () => {
    //     let data = searchData.map((item) => {
    //         return {...item, 
    //             payAmount:(item.payAmount/100).toString(), 
    //             requestAmount:(item.requestAmount/100).toString()
    //         }
    //     })
    //     let date = dateInNumbers();
    //     let workbook = XLSX.utils.book_new();
    //     let worksheet = XLSX.utils.json_to_sheet(data);
    //     XLSX.utils.book_append_sheet(workbook, worksheet, "TxnReport");
    //     XLSX.writeFile(workbook, `TxnReport_${date}.xlsx`);
    // }

    const handleFileUpload = (e) => {
        let file = e.target.files[0]; 
        if (file) {
            let reader = new FileReader(); 
            reader.onload = (event) => {
                let arrayBuffer = event.target.result; 
                let workbook = XLSX.read(arrayBuffer, { type: "array" });
                let sheetName = workbook.SheetNames[0]; 
                let sheet = workbook.Sheets[sheetName]; 
                let jsonData = XLSX.utils.sheet_to_json(sheet);
                setReversalData(jsonData); 
            };
            reader.readAsArrayBuffer(file); 
        }
    };

    const reversalHandler = async () => {
            // console.log(reversalData)
            setLoaderON(true)
        try {
            let postSetting = postApiSetting(reversalData)
            let res = await fetch('/Admin/api/Admin/manualReversal', postSetting);
            let result = (res.status === 200) ? await res.json(): "";
            if(res.status !== 200){
                setLoaderON(false)
                if(res.status === 401)
                { 
                    setAuth(false)
                    toast.error("Session Expired !", {position: 'top-center',});
                    navigate("/");                  
                    sessionStorage.clear();
                }else{
                alert('something went wrong : ' + res.status)
            }
            }else{
                if(result.data.responseCode === '00'){
                    setLoaderON(false)
                    alert('SUCCESS : '+result.data.responseMsg)
                    setReversalData([])
                }else{
                    setLoaderON(false)
                    alert('FAILED : '+result.data.responseMsg)
                }
            }
        } catch (error) {
            setLoaderON(false)
            console.log(error)
        }
    }

    return (<>
        {/* <SidebarNavigation /> */}
        {loaderON && <PageLoader />}
        <ToastContainer />
        <section className="transaction-page">
            <Navbar title="REVERSAL" />
            <div className="container-fluid pe-3">
                <div className="main-content my-3">
                    <h6 className="mb-3">Reversal</h6>

                    <form className="reversal-form mb-4">
                        <label className="form-label" htmlFor="reversalFile">Upload reversal sheet</label>
                        <div className="input-group">
                            <input id="reversalFile" type="file" className="form-control shadow-none" accept=".xlsx, .xls" onChange={handleFileUpload} />
                            <label className="input-group-text" htmlFor="reversalFile">Upload</label>
                        </div>
                    </form>

                    <PagiSearch setSearch={setSearch}
                    totalEntries={searchData.length}
                    setStartOffset={setStartOffset}
                    setTableDataStatus={setTableDataStatus} />

                    <div className="table-responsive my-2 com-table">
                    <table className="table table-bordered mb-1">
                        <thead>
                            <tr>
                                <th>S.No.</th>
                                <th>User Id</th>
                                <th>Mid</th>
                                <th>Wallet Id</th>
                                <th>Me Trn Ref Id</th>
                                <th>Txn Ref No</th>
                                <th>Reversal Amount</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentItems.length < 1 ? <TableStatusRow colSpan={8} status={tableDataStatus} /> :
                            currentItems.map((item,index) => {
                                return (
                                <tr key={index}>
                                    <td>{startOffset + index + 1}</td>
                                    <td>{item.userId}</td>
                                    <td>{item.mid}</td>
                                    <td>{item.walletId}</td>
                                    <td>{item.meTrnRefId}</td>
                                    <td>{item.txnRefNo}</td>
                                    <td>{item.reversalAmount}</td>
                                    <td><StatusBadge status={item.txnstatus} /></td>
                                </tr>
                                )
                            })}
                        </tbody>
                    </table>
                    </div>

                    <Pagination setStartOffset={setStartOffset}
                    pageCount={pageCount} itemsPerPage={itemsPerPage} />

                    <div className="text-center">
                   {loaderON ? "" : <button type="button" className="btn _themebg-0 text-white" onClick={reversalHandler}>REVERSAL</button>}
                    </div>

                </div>
            </div>
        </section>
    </>)
}